// Format date string to display format
export function formatDate(dateStr) {
  // Handle YYYY-MM format
  if (dateStr.match(/^\d{4}-\d{2}$/)) {
    const [year, month] = dateStr.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1); // Month is 0-based
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
    });
  }
  
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
  });
}

// Calculate duration between two dates in years and months
function calculateDuration(startDate, endDate) {
  const years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  
  // Adjust for negative months
  if (months < 0) {
    months += 12;
  }
  
  let duration = '';
  if (years > 0) {
    duration += `${years} year${years > 1 ? 's' : ''} `;
  }
  if (months > 0 || (months === 0 && years === 0)) {
    duration += `${months} month${months > 1 ? 's' : ''}`;
  }
  return duration.trim();
}

// Parse date string to Date object
function parseDate(dateStr) {
  if (dateStr === "Present") {
    return new Date();
  }
  
  if (dateStr.match(/^\d{4}-\d{2}$/)) {
    const [year, month] = dateStr.split('-');
    return new Date(parseInt(year), parseInt(month) - 1);
  }
  
  return new Date(dateStr);
}

// Check if experiences overlap
export function checkOverlap(exp1, exp2) {
  const start1 = parseDate(exp1.start);
  const end1 = parseDate(exp1.end);
  const start2 = parseDate(exp2.start);
  const end2 = parseDate(exp2.end);

  return start1 <= end2 && start2 <= end1;
}

// Process experience data for sorting and overlap detection
export function processExperiences(experiences) {
  return experiences
    .map((exp) => ({
      ...exp,
      startDate: parseDate(exp.start),
      endDate: parseDate(exp.end)
    }))
    .sort((a, b) => a.startDate - b.startDate);
} 